import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../authContext/authContext";
import { usePortal } from "../authContext/portalContext";

// Guards every page that belongs to one portal ("admin" = admin + operator
// back office, "therapist", "patient"). A page is only reachable when the
// account has that portal AND is currently viewing it — a dual-role account
// viewing the patient portal can't open therapist or admin URLs, it has to
// switch portals from the sidebar first. Anything else lands on /dashboard,
// which renders the active portal's own dashboard (DashboardRouter).
// `adminOnly` further restricts an admin-portal page to the admin role
// (operators share the admin portal but not these pages).
//
// This only hides UI — the backend enforces the same rules on every API call.
function PortalRoute({ portal, adminOnly = false, children }) {
  const { isAuthenticated, isAdmin } = useAuth();
  const { availablePortals, activePortal } = usePortal();

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!availablePortals.includes(portal) || activePortal !== portal) {
    return <Navigate to="/dashboard" replace />;
  }
  if (adminOnly && !isAdmin) return <Navigate to="/dashboard" replace />;

  return children;
}

export default PortalRoute;
